module.exports = __webpack_public_path__ + "media/applicants/balloons-281eb4ad.png";